import React, { HTMLAttributes } from 'react'
import classNames from 'classnames'
import { CaretLeftIcon } from '@/atoms/Icons/CaretLeftIcon'
import { InternalLink } from '@/atoms/InternalLink'
import { ParagraphSM } from '@/atoms/Typography'
import { paths, slugs } from '@/constants'
import { useTranslate } from '@/utils/translate/translate-client'

interface BreadcrumbProps extends HTMLAttributes<HTMLElement> {
  projectSlug: string
  projectName: string
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ className, projectSlug, projectName }) => {
  const { t } = useTranslate('common')

  return (
    <div className={classNames('line-clamp-1 pl-4', className)}>
      <CaretLeftIcon className="mr-2 inline" color="white" />
      <ParagraphSM className="text-white" as={(p) => <span {...p} />}>
        <InternalLink href={paths.watch.index}>{t('watch', 'Watch')}</InternalLink>
      </ParagraphSM>
      {projectSlug !== slugs.forYourConsideration && (
        <>
          <ParagraphSM className="mx-2 text-gray-600" as={(p) => <span {...p} />}>
            /
          </ParagraphSM>
          <ParagraphSM className="text-white" as={(p) => <span {...p} />}>
            <InternalLink href={`${paths.watch.index}/${projectSlug}`}>{projectName}</InternalLink>
          </ParagraphSM>
        </>
      )}
    </div>
  )
}
